import type { DataTableHeader } from '@/types/vuetify';

export function createLeaguesPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('leagues.name'),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 280,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('leagues.sport'),
            value: 'sportId',
            key: 'sportId',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 100,
            width: 100,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('leagues.bookmakerId'),
            value: 'internalId',
            key: 'internalId',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 120,
            width: 120,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('leagues.customLeagueNameId'),
            value: 'customLeagueDisplay',
            key: 'customLeagueDisplay',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 240,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('leagues.gameCount'),
            value: 'gamesCount',
            key: 'gamesCount',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 100,
            width: 100,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-0 pr-1' },
            headerProps: { class: 'nowrap' },
        },
    ];
}
